<template>
  <div class="col-sm-12 cart-coupon" v-bind:class="className">
    <div class="row" v-if="!hiddenCouponInputs">
      <div :class="getCSSInput">
        <input
          type="text"
          class="form-control"
          v-model="CouponCode"
          placeholder="Discount Code"
          @keydown.enter.prevent
        />
        <img
          :style="getQrStyle"
          @click="openScanner()"
          v-if="showQrCodeScannerIcon && isMobile() && !isChromeIos"
          class="qrscanner-icon"
          src="../../../../src/assets/qrcode-icon.png"
          alt="Qr code scanner"
        />
      </div>
      <div :class="getCSSBtn">
        <button
          type="button"
          :disabled="proccessing"
          class="btn btn-primary w-85 d-flex justify-content-center"
          :style="btnStyle"
          @click="ApplyCoupon"
        >
          <span v-show="proccessing">
            <i class="spin-sm" />
          </span>
          <i v-show="!proccessing && isMobile()" class="material-icons m-0"
            >forward</i
          >
          {{ getApplyText }}
        </button>
      </div>
    </div>
    <div class="row" v-if="!hiddenCouponInputs">
      <div class="col-sm-12 color-red">{{ CouponMessage }}</div>
    </div>
    <div
      class="coupons-countauner"
      :class="{ 'coupons-countainer-margin': hiddenCouponInputs }"
      v-if="CurrentCoupons.length"
    >
      <div class="coupon-validated">
        <span
          class="coupon-code"
          :class="{
            used:
              used_coupons.indexOf(couponItem.CouponCode) > -1 ||
              giftUsedCoupons.indexOf(couponItem.CouponCode) > -1
          }"
          :title="
            used_coupons.indexOf(couponItem.CouponCode) > -1 ||
            giftUsedCoupons.indexOf(couponItem.CouponCode) > -1
              ? 'Used'
              : 'unused'
          "
          v-for="(couponItem, index) in CurrentCoupons"
          :key="index"
        >
          <img class="coupon-image" :src="ImgInfo" />
          {{ couponItem.CouponCode }}
          <span
            class="remove-coupon"
            @click="remove_coupon(couponItem.CouponCode)"
            title="remove"
            >X</span
          >
        </span>
      </div>
    </div>
    <div class="col-sm-12 cart-coupon" v-bind:class="className">
      <span
        class="text-danger"
        v-show="
          (isGift && giftDiscount == 0 && CurrentCoupons.length > 0) ||
            (!isGift && discount == 0 && CurrentCoupons.length > 0)
        "
        >{{ $t("message.couponDoesNotApplyToAnyItems") }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CouponServiceApi } from "../../../api/services/couponService.js";
export default {
  name: "CouponComponent",
  components: {},
  props: {
    className: {
      type: String,
      default: ""
    },
    ForMobile: {
      type: Boolean,
      default: false
    },
    qrcode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      CouponCode: "",
      CouponMessage: "",
      proccessing: false,
      showQrCodeScannerIcon: true
    };
  },
  mounted() {
    if (this.qrcode && this.qrcode.length > 0) {
      this.applyCoupon(this.qrcode);
    }
  },
  computed: {
    ...mapGetters([
      "used_coupons",
      "giftUsedCoupons",
      "getApplyMultiCoupon",
      "discount",
      "giftDiscount",
      "mobileStyles",
      "desktopStyles",
      "isGift",
      "giftCoupons",
      "coupons"
    ]),
    isChromeIos() {
      return navigator.userAgent.match("CriOS");
    },
    getQrStyle() {
      var marginLeft = (window.screen.width / 12) * 8 - 70;
      return "margin-left:" + marginLeft + "px";
    },
    CurrentCoupons() {
      return this.isGift ? this.giftCoupons : this.coupons;
    },

    ImgInfo() {
      return require("../../../assets/Tag.png");
    },
    getApplyText() {
      return this.ForMobile || this.proccessing ? "" : "Apply";
    },

    getCSSInput() {
      let id = 8;
      return this.ForMobile ? "col-" + id : "col-sm-" + id;
    },

    getCSSBtn() {
      let id = 4;
      return this.ForMobile ? "col-" + id : "col-sm-" + id;
    },
    hiddenCouponInputs() {
      return !this.getApplyMultiCoupon && this.CurrentCoupons.length > 0;
    },
    btnStyle() {
      return this.isMobile() ? this.mobileStyles.btn : this.desktopStyles.btn;
    }
  },
  methods: {
    ...mapActions([
      "insertErrorlog",
      "addCouponToCart",
      "removeCouponfromCart"
    ]),
    openScanner() {
      this.$router.push({
        name: "qrCodeScanner",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    applyCoupon(code) {
      this.CouponCode = code;
      this.ApplyCoupon();
    },
    remove_coupon(coupon) {
      this.removeCouponfromCart(coupon);
    },

    ApplyCoupon() {
      this.CouponMessage = "";
      var that = this;
      this.proccessing = true;
      if (!this.CouponCode || !this.CouponCode.trim()) {
        that.CouponMessage = "Please enter the Discount Code";
        that.proccessing = false;
        return;
      }
      CouponServiceApi.IsValidated(this.CouponCode, this.$route.params.storeid)
        .then(response => {
          if (response.data.Success) {
            var coupon = response.data.Coupon;
            that.addCouponToCart(coupon);
            that.CouponCode = "";
          } else {
            that.CouponMessage = response.data.Status.Message;
          }
          that.proccessing = false;
        })
        .catch(error => {
          that.CouponMessage = "unknown error in coupon validating";
          that.proccessing = false;
          that.insertErrorlog([
            "coupon",
            error.message,
            that.$router.currentRoute.fullPath
          ]);
        });
    }
  }
};
</script>
